App.modules.storiesSlider = (() => {
    let storiesSlider, currentStory, dialog;
    function setInstagram() {
        if (typeof instgrm != 'undefined') {
            instgrm.Embeds.process();
        } else {
            const script = document.createElement('script');
            script.setAttribute('defer', true)
            script.setAttribute('async', true)
            script.setAttribute('src', '//www.instagram.com/embed.js')
            document.head.appendChild(script)
        }
    }
    function setTiktok() {

        const script = document.createElement('script');
        script.setAttribute('defer', true)
        script.setAttribute('async', true)
        script.setAttribute('src', '//www.tiktok.com/embed.js')
        document.head.appendChild(script)

    }

    function videoCode(a) {
        const url = a.href;
        const ar = a.offsetWidth / a.offsetHeight;
        const w = Math.max(a.offsetWidth, (20 * window.innerWidth) / 100);
        if (url.includes('instagram')) {
            let code = getComment(a);
            if (code) {
                return { code, set: setInstagram };
            }
            return {
                code: `<blockquote class="instagram-media" data-instgrm-permalink="${url}" data-instgrm-version="14" style="min-width:initial !important;width:${w}px !important;aspect-ratio:${ar} !important">Post Instagram <a href="${url}">Voir sur instagram.com</a></blockquote>`, set: setInstagram
            };
        } else if (url.includes('tiktok')) {
            let code = getComment(a);
            if (code) {
                return { code, set: setTiktok };
            }

            const id = url.split('?')[0].split('/').pop()
            if (id) {
                return { code: `<blockquote class="tiktok-embed" cite="${url}" data-video-id="${id}" style="max-width: initial;min-width: initial;width:${w}px !important;aspect-ratio:${ar} !important" >TikTok</blockquote> `, set: setTiktok };
            }
        }
    }

    function closeStory() {
        dialog?.remove();
    }
    function handleScroll() {
        const scrollContainer = dialog.querySelector('section'); // Adjust the selector to your specific div
        const videos = scrollContainer.querySelectorAll('video');

        const options = {
            root: scrollContainer,
            rootMargin: '0px',
            threshold: 0.7 // Ensure 100% of the item is visible to trigger playing
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.muted = dialog.dataset.muted=="true"
                    entry.target.currentTime = 0
                    entry.target.play();
                } else {
                    entry.target.pause();
                }
            });
        }, options);

        videos.forEach(video => {
            observer.observe(video);
        });
    }
    function openStory(article) {
        if (!article) return;
        dialog = document.querySelector(`#stories-slider-dialog`)
        if (!dialog) {
            dialog = document.createElement('dialog');
            dialog.dataset.muted=true;
            dialog.innerHTML = `<section><div></div></section>`;
            dialog.id = `stories-slider-dialog`;
            storiesSlider.querySelectorAll('article[data-video]').forEach(item => {
                const video_url = item.dataset.video;
                const poster = item.querySelector('img').src;
                const code = `<video playsinline loop="true" poster="${poster}">
                <source src="${video_url}" type="video/mp4">
                <source src="https://tools.sopress.dev/convertVideo/?v=${video_url}&to=webm" type="video/webm">
            </video>`
                const video = document.createElement('article')
                video.dataset.video = video_url
                video.innerHTML = code;
                video.addEventListener('click', () => {
                    dialog.dataset.muted = !(dialog.dataset.muted=='true');
                    dialog.querySelectorAll('video').forEach(video => {
                        if(video.paused) return;
                        video.muted = dialog.dataset.muted=='true'
                    })
                })
                dialog.querySelector('div').append(video)
            })

            document.body.append(dialog)

            dialog.addEventListener('click', e => {
                const button = e.target.closest('button');
                if (button) {
                    const action = button.dataset.action;
                    if (!action) return;
                    e.preventDefault();

                    console.log(action);
                    if (action == 'next') {
                        openStory(currentStory.nextElementSibling)
                    } else {
                        openStory(currentStory.previousElementSibling)
                    }
                }
                if (e.target == dialog) {
                    closeStory()
                }
            })
            handleScroll()
        }
        dialog.showModal();
        const video_url = article.dataset.video
        dialog.querySelector(`[data-video="${video_url}"]`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        return true;
    }
    // function openStory(article) {
    //     if (!article) return;
    //     closeStory();
    //     const video_url = article.dataset.video;
    //     const code = `<video loop="true">
    //         <source src="${video_url}" type="video/mp4">
    //         <source src="https://tools.sopress.dev/convertVideo/?v=${video_url}&to=webm" type="video/webm">
    //     </video>`
    //     currentStory = article;
    //     dialog = document.createElement('dialog');
    //     dialog.innerHTML = `<div>${code}</div><nav><button data-action="prev"></button><button data-action="next"></button></nav>`;

    //     storiesSlider.append(dialog)
    //     dialogStart();
    //     dialog.showModal();
    //     dialog.querySelector('video').play()
    //     emettreEvenement('video-play', { video_url });

    //     dialogEnd()
    //     return true;
    // }
    function dialogStart() {
        dialog.showModal();
        dialog.querySelector('div').dataset.loading = true
    }

    function dialogEnd() {
        setTimeout(() => {
            delete dialog.querySelector('div').dataset.loading;
        }, 1000)
    }
    return {

        start() {
            storiesSlider = document.querySelector('.stories-slider');
            if (!storiesSlider) return;

            storiesSlider.addEventListener('click', e => {
                const article = e.target.closest('article');

                if (article) {
                    if (openStory(article)) {
                        return e.preventDefault();
                    }
                }
            });


        }
    }
})();

